import { Phone, CalendarClock } from "lucide-react";
import { Link } from "react-router-dom";

export default function TopBar() {
  return (
    <div
      data-testid="top-utility-bar"
      className="bg-navy-deep text-white text-xs border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 h-10 flex items-center justify-between gap-4">
        <p className="flex items-center gap-2 font-mono uppercase tracking-[0.18em] text-[10px] sm:text-[11px] text-slate-300 truncate">
          <span className="inline-block h-1.5 w-1.5 rounded-full bg-ember animate-pulse-dot shrink-0" />
          <span className="hidden md:inline">Available 24/7 for Emergency Repairs across Central Louisiana</span>
          <span className="md:hidden">24/7 Emergency Repairs — Central Louisiana</span>
        </p>
        <div className="flex items-center gap-4 shrink-0">
          <a
            data-testid="topbar-call-link"
            href="tel:3183122112"
            className="flex items-center gap-1.5 font-mono text-[11px] tracking-wider text-frost hover:text-white transition-colors"
          >
            <Phone className="h-3 w-3" />
            (318) 312-2112
          </a>
          <Link
            data-testid="topbar-schedule-link"
            to="/contact"
            className="hidden sm:flex items-center gap-1.5 font-mono text-[11px] tracking-wider text-ember hover:text-white transition-colors"
          >
            <CalendarClock className="h-3 w-3" />
            SCHEDULE SERVICE
          </Link>
        </div>
      </div>
    </div>
  );
}
